module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_SE.3f4951e0.txt";